var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApartmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 25,
    viewBox: "0 0 29 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1346 3.33419C22.9826 3.33192 22.8373 3.2705 22.7298 3.16295C22.6223 3.05541 22.5609 2.9102 22.5586 2.75813V1.06513C22.5712 0.92047 22.6376 0.785797 22.7446 0.687685C22.8517 0.589573 22.9916 0.535156 23.1368 0.535156C23.282 0.535156 23.4219 0.589573 23.529 0.687685C23.636 0.785797 23.7024 0.92047 23.715 1.06513V2.75813C23.7175 2.83483 23.7042 2.91121 23.6758 2.98251C23.6475 3.05381 23.6047 3.11851 23.5503 3.17256C23.4958 3.22661 23.4308 3.26886 23.3593 3.29667C23.2878 3.32447 23.2113 3.33725 23.1346 3.33419Z",
    fill: "#399E79",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.80649 3.33419C4.65478 3.33083 4.51021 3.26906 4.4029 3.16174C4.2956 3.05443 4.23383 2.90986 4.23047 2.75813V1.06513C4.24309 0.92047 4.30948 0.785797 4.41652 0.687685C4.52357 0.589573 4.66349 0.535156 4.8087 0.535156C4.9539 0.535156 5.09382 0.589573 5.20087 0.687685C5.30791 0.785797 5.3743 0.92047 5.38692 1.06513V2.75813C5.38463 2.91096 5.32261 3.05679 5.21413 3.16446C5.10564 3.27212 4.95932 3.33306 4.80649 3.33419Z",
    fill: "#399E79",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1563 0H9.79297V1.6886H18.1563V0Z",
    fill: "#399E79",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.92418 2.80469V4.4493H3.69922V2.80469H4.8117H5.92418Z",
    fill: "#398495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2484 2.80469V4.4493H22.0234V2.80469H23.1359H24.2484Z",
    fill: "#398495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8 24.4063H8.08594V1.60156H19.7824L19.8 24.4063Z",
    fill: "#399E79",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9291 19.9766H12.0156V24.4267H15.9291V19.9766Z",
    fill: "#D8F2F1",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.14429 4.40234V24.406H1.98828V4.40234H8.14429Z",
    fill: "#399E79",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9373 4.40234V24.406H19.7812V4.40234H25.9373Z",
    fill: "#399E79",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2492 21.6602H23.1367V22.7727H24.2492V21.6602Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2492 19.9766H23.1367V21.0891H24.2492V19.9766Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2492 18.3242H23.1367V19.4368H24.2492V18.3242Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2492 16.6367H23.1367V17.7492H24.2492V16.6367Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2492 14.9844H23.1367V16.0969H24.2492V14.9844Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2492 13.2969H23.1367V14.4094H24.2492V13.2969Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2492 11.6523H23.1367V12.7649H24.2492V11.6523Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2492 9.95703H23.1367V11.0696H24.2492V9.95703Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2492 8.3125H23.1367V9.42505H24.2492V8.3125Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2492 6.62891H23.1367V7.74143H24.2492V6.62891Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6047 21.6602H21.4922V22.7727H22.6047V21.6602Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6047 19.9766H21.4922V21.0891H22.6047V19.9766Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6047 18.3242H21.4922V19.4368H22.6047V18.3242Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6047 16.6367H21.4922V17.7492H22.6047V16.6367Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6047 14.9844H21.4922V16.0969H22.6047V14.9844Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6047 13.2969H21.4922V14.4094H22.6047V13.2969Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6047 11.6523H21.4922V12.7649H22.6047V11.6523Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6047 9.95703H21.4922V11.0696H22.6047V9.95703Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6047 8.3125H21.4922V9.42505H22.6047V8.3125Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6047 6.62891H21.4922V7.74143H22.6047V6.62891Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6906 16.6367H17.5781V18.8618H18.6906V16.6367Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6906 14.9844H17.5781V16.0969H18.6906V14.9844Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6906 12.1836H17.5781V14.4087H18.6906V12.1836Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6906 10.5391H17.5781V11.6516H18.6906V10.5391Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6906 7.74219H17.5781V9.96726H18.6906V7.74219Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6906 6.08984H17.5781V7.20239H18.6906V6.08984Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6906 3.28906H17.5781V5.51413H18.6906V3.28906Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0422 16.6367H15.9297V18.8618H17.0422V16.6367Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0422 14.9844H15.9297V16.0969H17.0422V14.9844Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0422 12.1836H15.9297V14.4087H17.0422V12.1836Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0422 10.5391H15.9297V11.6516H17.0422V10.5391Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0422 7.74219H15.9297V9.96726H17.0422V7.74219Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0422 6.08984H15.9297V7.20239H17.0422V6.08984Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0422 3.28906H15.9297V5.51413H17.0422V3.28906Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3547 16.6367H14.2422V18.8618H15.3547V16.6367Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3547 14.9844H14.2422V16.0969H15.3547V14.9844Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3547 12.1836H14.2422V14.4087H15.3547V12.1836Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3547 10.5391H14.2422V11.6516H15.3547V10.5391Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3547 7.74219H14.2422V9.96726H15.3547V7.74219Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3547 6.08984H14.2422V7.20239H15.3547V6.08984Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3547 3.28906H14.2422V5.51413H15.3547V3.28906Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7062 16.6367H12.5938V18.8618H13.7062V16.6367Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7062 14.9844H12.5938V16.0969H13.7062V14.9844Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7062 12.1836H12.5938V14.4087H13.7062V12.1836Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7062 10.5391H12.5938V11.6516H13.7062V10.5391Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7062 7.74219H12.5938V9.96726H13.7062V7.74219Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7062 6.08984H12.5938V7.20239H13.7062V6.08984Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7062 3.28906H12.5938V5.51413H13.7062V3.28906Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0148 16.6367H10.9023V18.8618H12.0148V16.6367Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0148 14.9844H10.9023V16.0969H12.0148V14.9844Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0148 12.1836H10.9023V14.4087H12.0148V12.1836Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0148 10.5391H10.9023V11.6516H12.0148V10.5391Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0148 7.74219H10.9023V9.96726H12.0148V7.74219Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0148 6.08984H10.9023V7.20239H12.0148V6.08984Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0148 3.28906H10.9023V5.51413H12.0148V3.28906Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3703 16.6367H9.25781V18.8618H10.3703V16.6367Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3703 14.9844H9.25781V16.0969H10.3703V14.9844Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3703 12.1836H9.25781V14.4087H10.3703V12.1836Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3703 10.5391H9.25781V11.6516H10.3703V10.5391Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3703 7.74219H9.25781V9.96726H10.3703V7.74219Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3703 6.08984H9.25781V7.20239H10.3703V6.08984Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3703 3.28906H9.25781V5.51413H10.3703V3.28906Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.45623 21.6602H5.34375V22.7727H6.45623V21.6602Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.45623 19.9766H5.34375V21.0891H6.45623V19.9766Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.45623 18.3242H5.34375V19.4368H6.45623V18.3242Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.45623 16.6367H5.34375V17.7492H6.45623V16.6367Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.45623 14.9844H5.34375V16.0969H6.45623V14.9844Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.45623 13.2969H5.34375V14.4094H6.45623V13.2969Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.45623 11.6523H5.34375V12.7649H6.45623V11.6523Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.45623 9.95703H5.34375V11.0696H6.45623V9.95703Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.45623 8.3125H5.34375V9.42505H6.45623V8.3125Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.45623 6.62891H5.34375V7.74143H6.45623V6.62891Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.8156 21.6602H3.70312V22.7727H4.8156V21.6602Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.8156 19.9766H3.70312V21.0891H4.8156V19.9766Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.8156 18.3242H3.70312V19.4368H4.8156V18.3242Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.8156 16.6367H3.70312V17.7492H4.8156V16.6367Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.8156 14.9844H3.70312V16.0969H4.8156V14.9844Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.8156 13.2969H3.70312V14.4094H4.8156V13.2969Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.8156 11.6523H3.70312V12.7649H4.8156V11.6523Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.8156 9.95703H3.70312V11.0696H4.8156V9.95703Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.8156 8.3125H3.70312V9.42505H4.8156V8.3125Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.8156 6.62891H3.70312V7.74143H4.8156V6.62891Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8713 24.9986H0.630896C0.550724 25.0056 0.469984 24.9958 0.393782 24.9699C0.31758 24.9441 0.247584 24.9026 0.188256 24.8482C0.128927 24.7938 0.0815621 24.7277 0.049154 24.6541C0.0167459 24.5804 0 24.5008 0 24.4203C0 24.3398 0.0167459 24.2602 0.049154 24.1866C0.0815621 24.1129 0.128927 24.0468 0.188256 23.9924C0.247584 23.938 0.31758 23.8966 0.393782 23.8707C0.469984 23.8448 0.550724 23.835 0.630896 23.842H27.8932C28.0453 23.8443 28.1905 23.9057 28.2981 24.0133C28.4056 24.1208 28.467 24.2661 28.4693 24.4181C28.4508 24.5686 28.3815 24.7082 28.2727 24.8138C28.1639 24.9194 28.0222 24.9846 27.8713 24.9986Z",
    fill: "#398596",
    fillOpacity: 0.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApartmentIcon);
export default __webpack_public_path__ + "static/media/ApartmentIcon.d2ca9595f9af6f642acf12132525a138.svg";
export { ForwardRef as ReactComponent };